module.exports = __webpack_public_path__ + "img/qrcode.c28ad330.jpg";